import React from 'react';
import PropTypes from 'prop-types';

import HotSpot from './HotSpot';
import { Tooltip } from './Tooltip';

const HotSpotWithTooltip = (props) => (
	<HotSpot show={props.show} {...props}>
		{props.children}
	</HotSpot>
);

HotSpotWithTooltip.propTypes = {
	show: PropTypes.bool,
	children: PropTypes.node,
};

export { Tooltip, HotSpot, HotSpotWithTooltip };
